import { render, staticRenderFns } from "./NoticeManagementView.vue?vue&type=template&id=62aa902d&"
import script from "./NoticeManagementView.vue?vue&type=script&lang=js&"
export * from "./NoticeManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports